<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row dense class="no-gutters pb-5">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line solo
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-select solo :items="[{ id: 'all', display: 'All' }, ...formattedAccountTypes]" item-text="display"
            item-value="id" v-model="selectedAccountType" append-icon="mdi-chevron-down" label="Account Type"
            class="custom-select"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="3">
          <v-select solo :items="[{ id: 'all', title: 'All' }, ...formattedCurrencyGroups]" item-text="title"
            item-value="id" v-model="selectedCurrencyGroup" append-icon="mdi-chevron-down" label="Currency Group"
            class="custom-select"></v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
        <advanced-rates-data-table :search="search" :levelCounts="levelCounts" :advancedrates="advancedrates">
        </advanced-rates-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import AdvancedRatesDataTable from './AdvancedRatesDataTable.vue';
import { mapState, mapActions } from "vuex";
import { PARTNERLIST__ACTIONS, COMMISSIONSETTINGS__ACTIONS } from "@/store/action-types";

export default {
  components: { AdvancedRatesDataTable },
  data() {
    return {
      search: "",
      selectedAccountType: null,
      selectedCurrencyGroup: null,
    };
  },
  computed: {
    ...mapState("partnerlist", ["advancedrates"]),
    ...mapState("commissionsettings", [
      "levelCounts",
      "accountTypes",
      "currencyGroups",
    ]),
    formattedAccountTypes() {
      return this.accountTypes
        ? this.accountTypes.map(type => ({
          id: type?.id,
          display: `${type?.account_type_display?.toUpperCase()} (${type?.LiveDemo} ${type?.Mt4Mt5})`,
        }))
        : [];
    },

    formatedAccountTypeName() {
      return this.accountTypes ? this.accountTypes?.find(account => account?.id ===
        this.selectedAccountType)?.account_type_display : null
    },

    formatedCurrencyGroupName() {
      return this.currencyGroups ? this.currencyGroups?.find(group => group?.id ===
        this.selectedCurrencyGroup)?.title : null
    },

    formattedCurrencyGroups() {
      return this.currencyGroups ? this.currencyGroups.map(type => ({
        id: type?.id,
        title: type?.title,
      })) : [];
    },
  },
  watch: {
    selectedAccountType(newValue) {
      this[PARTNERLIST__ACTIONS.ADVANCEDRATES]({
        partner_id: this.$route.query.id,
        account_type: newValue === 'all' ? null : newValue,
      });
    },
    selectedCurrencyGroup(newValue) {
      this[PARTNERLIST__ACTIONS.ADVANCEDRATES]({
        partner_id: this.$route.query.id,
        currency_group: newValue === 'all' ? null : newValue,
      });
    }
  },
  methods: {
    ...mapActions("partnerlist",
      [
        PARTNERLIST__ACTIONS.ADVANCEDRATES,
      ]
    ),
    ...mapActions("commissionsettings", [COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS]),
  },
  async mounted() {
    await this[COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS]();
    await this[PARTNERLIST__ACTIONS.ADVANCEDRATES]({ partner_id: this.$route.query.id });
  },
};
</script>